export type Days = {
  day: string;
  label: string;
};

export const days: Days[] = [
  { day: 'monday', label: 'Monday' },
  { day: 'tuesday', label: 'Tuesday' },
  { day: 'wednesday', label: 'Wednesday' },
  { day: 'thursday', label: 'Thursday' },
  { day: 'friday', label: 'Friday' },
  { day: 'saturday', label: 'Saturday' },
];

export type ClassInfo = {
  className: string;
  time: string;
  trainer: string;
};

export type ClassesByDay = {
  [day: string]: ClassInfo[];
};

export const classesByDay: ClassesByDay = {
  monday: [
    { className: 'Fitness', time: '9:00am - 10:00am', trainer: 'Rajveer Singh' },
    {
      className: 'Body Building',
      time: '10:00pm - 11:00pm',
      trainer: 'Kabir Yadav',
    },
    {
      className: 'Running',
      time: '4:00pm - 5:00pm',
      trainer: 'Riya Chahal',
    },
    {
      className: 'Cycling',
      time: '6:00pm - 7:00pm',
      trainer: 'Rohan Malik',
    },
  ],
  tuesday: [
    {
      className: 'Boxing',
      time: '10:00pm - 11:00pm',
      trainer: 'Arjun Rana',
    },
    {
      className: 'Yoga',
      time: '4:00pm - 5:00pm',
      trainer: 'Meera Singh',
    },
    {
      className: 'Crossfit',
      time: '6:00pm - 7:00pm',
      trainer: 'Vikram Solanki',
    },
  ],
  wednesday: [
    { className: 'Cycling', time: '9:00am - 10:00am', trainer: 'Rajveer Singh' },
    {
      className: 'Body Building',
      time: '10:00pm - 11:00pm',
      trainer: 'Kabir Yadav',
    },
    {
      className: 'Fitness',
      time: '4:00pm - 5:00pm',
      trainer: 'Rajveer Singh',
    },
    {
      className: 'Running',
      time: '6:00pm - 7:00pm',
      trainer: 'Riya Chahal',
    },
  ],
  thursday: [
    { className: 'Fitness', time: '9:00am - 10:00am', trainer: 'Rajveer Singh' },
    {
      className: 'Body Building',
      time: '10:00pm - 11:00pm',
      trainer: 'Kabir Yadav',
    },
    {
      className: 'Running',
      time: '4:00pm - 5:00pm',
      trainer: 'Riya Chahal',
    },
  ],
  friday: [
    { className: 'Crossfit', time: '9:00am - 10:00am', trainer: 'Vikram Solanki' },
    {
      className: 'Karate',
      time: '10:00pm - 11:00pm',
      trainer: 'Devender Chauhan',
    },
    {
      className: 'Meditation',
      time: '4:00pm - 5:00pm',
      trainer: 'Priya Sharma',
    },
    {
      className: 'Workout',
      time: '6:00pm - 7:00pm',
      trainer: 'Rohan Malik',
    },
  ],
  saturday: [
    {
      className: 'Power Lifting',
      time: '9:00am - 10:00am',
      trainer: 'Vikram Solanki',
    },
    {
      className: 'Boxing',
      time: '10:00pm - 11:00pm',
      trainer: 'Arjun Rana',
    },
    {
      className: 'Yoga',
      time: '4:00pm - 5:00pm',
      trainer: 'Meera Singh',
    },
  ],
};
